// Lê o campo Comentario do processo em qualquer formato já gravado no banco:
// lista JSON (atual), um objeto só, ou texto simples (importação por CSV,
// Patrimônio, sistemas antigos). Texto simples vira um comentário interno,
// para não sumir da tela nem ser apagado no próximo salvamento.
export const lerComentarios = (raw) => {
  if (raw === null || raw === undefined) return []
  let valor = raw
  if (typeof raw === 'string') {
    const texto = raw.trim()
    if (!texto) return []
    try {
      valor = JSON.parse(texto)
    } catch (err) {
      return [{ comentario: texto, ResponsavelNome: 'Registro anterior', data: null }]
    }
  }
  const item = (c) => {
    if (c && typeof c === 'object') return c
    const texto = String(c ?? '').trim()
    return texto ? { comentario: texto, ResponsavelNome: 'Registro anterior', data: null } : null
  }
  if (Array.isArray(valor)) return valor.map(item).filter(Boolean)
  const unico = item(valor)
  return unico ? [unico] : []
}
